import * as React from 'react';
import Button from 'react-bootstrap/Button';

import './style.scss';

interface IAttachButtonProps {
  onClick: TButtonOnClick;
  bsStyle?: ButtonStyle;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
}

interface IAttachButtonState {}

export default class AttachButton extends React.Component<IAttachButtonProps, IAttachButtonState> {
  static defaultProps = {
    count: 0,
    bsStyle: ButtonStyle.DEFAULT,
    onClick: null,
    className: 'attach-btn',
    disabled: false,
  };

  render() {
    const { onClick, style, disabled } = this.props;

    return <Button style={style} className={this.props.className} onClick={onClick} disabled={disabled} />;
  }
}
